import React from "react";
import { useSelector } from "react-redux";

import TopNavBarSpan from "./TopNavBarSpan";

const TopNavBar = ({ topTab, setTopTab, tabList, isMobile }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "1.5vw",
        borderBottom: "1px solid #EBEBEB",
        fontSize: isMobile ? "14px" : "18px",
        height: isMobile ? "36px" : "50px",
        backgroundColor: "#FFF",
      }}
    >
      {tabList.map((tab) => (
        <TopNavBarSpan
          key={tab.name}
          topTab={topTab}
          setTopTab={setTopTab}
          tabName={tab.name}
          tabText={tab.text}
        />
      ))}
    </div>
  );
};

export default TopNavBar;
